import { DataSource } from '@angular/cdk/table';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ColumnConfig, DynamicTableModule } from 'material-dynamic-table';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [DynamicTableModule],
})
export class TableComponent implements OnInit {
  @Input() columns: ColumnConfig[];
  @Input() dataSource: DataSource<any>;
  @Input() pageSize = 20;
  @Input() pageSizeOptions = [20, 50, 100];
  @Input() showFilters = true;
  @Input() stickyHeader = false;
  @Input() paginator: MatPaginator;

  constructor() {}

  ngOnInit() {}
}
